import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
  language_selector: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchHeaderAndFooter = createAsyncThunk(
  "headerAndFooter/fetchHeaderAndFooter",
  async (country) => {
    return fetch(`${baseUrl}/api/header-and-footer/${country?.countryCode}/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Accept-Language":
          country.language === "en" ? "en-UK" : country.language,
      },
    }).then((res) => errorStatusProvider(res));
  }
);

export const getHeaderAndFooter =
  (countryCode, language) => async (dispatch) => {
    if (!countryCode || !language) return null;
    const result = await dispatch(
      fetchHeaderAndFooter({ countryCode, language })
    );
    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));
    return data;
  };

export const headerAndFooterSlice = createSlice({
  name: "welcomeScreen",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeaderAndFooter.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHeaderAndFooter.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
        state.language_selector = action.payload.data.language_selector;
      })
      .addCase(fetchHeaderAndFooter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default headerAndFooterSlice.reducer;
